<div class="container">
  <h3>process<span> we follow</span></h3>
  <p>
    At GenAI Agency, we blend creativity with technology to deliver top-notch
    digital marketing and custom software solutions for web and mobile apps. Our
    straightforward approach starts with understanding your unique needs,
    followed by crafting personalized strategies that highlight your brand's
    digital presence. Let us help you stand out in the digital landscape with
    solutions that are both effective and imaginative.
  </p>
  <div class="process-steps">
    <div>
      <span>01</span>
      <h4>project researching</h4>
      <p class="step-desc">
          We thoroughly understand your needs and the market, ensuring that our solutions perfectly match your requirements.
      </p>
    </div>
    <div class="center">
      <span>02</span>
      <h4>evaluate plans</h4>
      <p class="step-desc">
        "Evaluate Plans" involves a meticulous review and adjustment of our strategies to ensure they match your goals and the insights we've gathered, ensuring the most effective way forward.
      </p>
    </div>
    <div>
      <span>03</span>
      <h4>best results</h4>
      <p class="step-desc">
        We work on executing our refined strategies to achieve excellent results. This phase focuses on applying our expertise to ensure the success and satisfaction of your project.
      </p>
    </div>
  </div>
</div>
